<template>
  <Panel>
    <template slot="panel">
      <Breadcrumb :routes="routes"></Breadcrumb>
      <MHistory v-if="$root.isMobile"></MHistory>
      <template v-else>
        <Title class="margin-y-15" :title="$root.language.history"></Title>
        <p class="font-20 weight-bold">{{$root.language.historyRow1}}</p>
        <p class="font-20 weight-bold margin-bottom-50">{{$root.language.historyRow2}}</p>
        <a-row :gutter="[64,8]">
          <a-col :xs="24" :sm="24" :md="24" :lg="8">
            <div class="img-title">TECHNOLOGY LEADERSHIP</div>
            <img src="@/assets/img/h-1.jpg" class="history-img" alt="">
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="8">
            <div class="img-title">INDUSTRY EXPERIENCE</div>
            <img src="@/assets/img/h-2.jpg" class="history-img" alt="">
          </a-col>
          <a-col :xs="24" :sm="24" :md="24" :lg="8">
            <div class="img-title">CUSTOMER VALUE</div>
            <img src="@/assets/img/h-3.jpg" class="history-img" alt="">
          </a-col>
        </a-row>
        <p class="font-16 margin-top-50"><span class="font-24 weight-bold">2007</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow3}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2008</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow4}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2014</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow5}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2015</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow6}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2016</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow7}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2019</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow8}}</p>
        <p class="font-16"><span class="font-24 weight-bold">2019</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow9}}</p>
        <div class="font-16"><span class="font-24 weight-bold">2020</span>
          <a-icon type="caret-right" :style="iconColor" /> {{$root.language.historyRow10}}</div>
      </template>
      <Space></Space>
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import Breadcrumb from '@/components/breadcrumb'
import Title from '@/components/title'
import Space from '@/components/space'
import MHistory from '@/mobile/history.vue'
export default {
  components: {
    Panel,
    Breadcrumb,
    Title,
    MHistory,
    Space
  },

  data () {
    return {
      routes: [{
        name: this.$root.language.jwisoftware,
        path: '/'
      },
      {
        name: this.$root.language.company,
        path: ''
      },
      {
        name: this.$root.language.history,
        path: '/company/history'
      }
      ],
      backgroundImg: {
        backgroundImage: `url(${require('@/assets/img/line.png')})`,
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'left center'
      },
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>

<style scoped>
  .history-title {
    padding: 8px 0;
    background: #5e5e5e;
    color: #fff;
    text-align: center;
    font-weight: bold;
  }

  .history-body {
    padding: 20px;
    background-color: white;
  }

  .padding-z-24 {
    padding: 24px;
  }

  .history-img {
    width: 400px;
    box-shadow: 1px 1px 25px 6px #ccc;
  }

  .margin-top-50 {
    margin-top: 60px;
  }

  .margin-bottom-50 {
    margin-bottom: 60px;
  }

  .img-title {
    position: relative;
    top: 167px;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .box-shadow {
    box-shadow: 1px 1px 25px 6px #ccc;
  }

</style>
